import render from './render'

export default {
  name: 'Conditions',

  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      showDialog: false,
      dialogData: undefined,
      dialogType: undefined
    }
  },

  render
}
